import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const LossInvestigationCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.5rem 0;
  min-width: 18rem;
  max-width: 26rem;
  white-space: normal;
`

export const LossCellEm = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
  font-variant-numeric: tabular-nums;
`

export const LossExplainerWrap = styled.div`
  margin-top: 1rem;
  padding: 0.5rem 0;
  border-top: 1px solid ${tokens.border.hairline};
`
